import VTooltip from '@dp-ui-kit/vue/components/tooltip/DpTooltipDirective';
import { TOOLTIP_DEFAULT_OPTIONS } from '@dp-ui-kit/vue/components/tooltip/config';

const { options } = VTooltip;

VTooltip.options = { ...options, ...TOOLTIP_DEFAULT_OPTIONS, defaultHtml: false };

export const dppTooltip = VTooltip;
